import './Modal.scss';

import type { ModalProps as AntdModalProps } from 'antd';
import { Modal as AntdModal } from 'antd';
import type { PropsWithChildren } from 'react';
import React from 'react';

interface ModalProps extends Omit<AntdModalProps, 'mask' | 'maskClosable'> {
  open: boolean;
  onClose: () => void;
  title?: string;
  actions?: React.ReactNode;
  className?: string;
  maskClosable?: boolean;
  width?: number;
  surviveClose?: boolean;
  footer?: React.ReactNode;
  subtitle?: string;
  mask?: boolean | { enabled?: boolean; blur?: boolean; closable?: boolean };
}

const Modal = (props: PropsWithChildren<ModalProps>) => {
  const {
    onClose,
    open,
    actions,
    children,
    className,
    maskClosable,
    surviveClose,
    title,
    width,
    footer,
    subtitle,
    closable,
    keyboard,
    mask: maskProp
  } = props;

  if (!open) return null;

  return (
    <div onClick={(e) => e.stopPropagation()} onSubmit={(e) => e.stopPropagation()}>
      <AntdModal
        open={open}
        closable={closable}
        keyboard={keyboard}
        footer={footer || null}
        title={
          <div className="Modal_header">
            <div className="Modal_header-title">
              {title}
              {subtitle && (
                <>
                  <span>•</span>
                  <span className="Modal_header-subtitle">{subtitle}</span>
                </>
              )}
            </div>
            <div>{actions}</div>
          </div>
        }
        width={width || 520}
        rootClassName={`Modal ${className || ''}`}
        className={`Modal ${className || ''}`}
        mask={maskProp !== undefined ? maskProp : { closable: maskClosable ?? false }}
        destroyOnHidden={!surviveClose}
        onCancel={onClose}
        onOk={onClose}
      >
        <div className="Modal_content">{children}</div>
      </AntdModal>
    </div>
  );
};

export default Modal;
